import type { ScaleBoundUnit, ScaleModel } from "~/types/hardware";

/** Whole number of decimals a CAS display can show; the wrapper rejects more. */
export const MAX_SCALE_DECIMALS = 4;

/**
 * What the wrapper assumes when no precision was declared at pairing. Kept in
 * step with the wrapper's own table so the slider starts where the driver is.
 */
const DEFAULT_DECIMALS: Record<ScaleBoundUnit, number> = {
  g: 0,
  kg: 3,
  lb: 2,
  oz: 1
};

export const defaultScaleDecimals = (
  model: ScaleModel | null,
  unit: ScaleBoundUnit
): number => {
  // CAS PD-II reports decigrams
  if (model === "pd2" && unit === "g") return 1;
  return DEFAULT_DECIMALS[unit];
};
